// Vendors
import React from 'react';
import { Typography } from '@mui/material';

// Components
import ReusablePopup from '@/components/organism/PopUp/ReusablePopup/ReusablePopup';

// Models
import { ContractDetails } from '@/utils/types/contractDetails';
import { POPUP_TYPES } from '@/utils/constants';
import { AuthState } from '@/store/features/auth/authSlice';
import { useAppSelector } from '@/hooks/storeHook';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  data: ContractDetails;
  handleContractListClick: () => void;
}

const CustomerDetailsPopup: React.FC<Props> = ({
  isOpen,
  onClose,
  data,
  handleContractListClick,
}) => {
  const user = useAppSelector((state: { auth: AuthState }) => state.auth.user);
  const isInternalUser = user?.apv_groups.includes('APV AppRole_AssurTrack Internal');
  const formatDateYear = (DateStr: string) => {
    const date = new Date(DateStr);
    return (
      `${(date.getMonth() + 1).toString().padStart(2, '0')}/` +
      `${date.getDate().toString().padStart(2, '0')}/` +
      date.getFullYear().toString()
    );
  };
  return (
    <ReusablePopup
      isOpen={isOpen}
      onClose={onClose}
      typeClassName="contract-details-popup"
      onFooterClick={handleContractListClick}
      header={data.customerName}
      type={POPUP_TYPES.CUSTOMER_DETAILS}
    >
      <Typography className="popup-content">
        Customer #: {data.customerId}
        {isInternalUser && <>| Class Code: {data.classCode}</>}
      </Typography>
      {data.email && <Typography className="popup-content">{data.email}</Typography>}
      <Typography className="popup-content">
        Origination Date: {formatDateYear(data.originationDate)}
      </Typography>
      <Typography className="popup-content">
        Maturity Date: {formatDateYear(data.maturityDate)}
      </Typography>
      <Typography className="popup-content">{data.address}</Typography>
      <Typography className="popup-state">
        {data.city}, {data.state} {data.zipCode}
      </Typography>
    </ReusablePopup>
  );
};

export default CustomerDetailsPopup;
